import { MarkerClusterer } from "@googlemaps/markerclusterer";

export function loadGmapScript() {

    if (!document.getElementById("map")) {
        return;
    }

    let api_key = "AIzaSyD0aNF3w3-BgwK1btNMT1FSp7qs0B1A3ec";
    let callback = "initClusterMap";
    let script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${api_key}&callback=${callback}&v=weekly`;
    // script.onload = gmapStylesInit;
    script.onerror = function () {
        alert("Error loading: " + this.src);
    };
    document.head.appendChild(script);

    searchButton();
    statusButton();
    viewButton();
    filterButton();
}

const mayBeFilterListings = function() {
        let filterValues = [];
        const urlParams = new URLSearchParams(window.location.search);
        const type = urlParams.get('type');
        const industry = urlParams.get('industry');
        const leaseforsale = urlParams.get('leaseforsale');
        const country = urlParams.get('country');
        const region = urlParams.get('region');
        const city = urlParams.get('city');
        const from = urlParams.get('from');
        const to = urlParams.get('to');

        if( !type &&
            !industry &&
            !leaseforsale &&
            !country &&
            !region &&
            !city &&
            !from &&
            !to
        ) {
            return;
        }

        console.log('mayBeFilterListings...');
        
        if( type ) {
            filterValues.push({
                type: [type]
            });
        }

        if( industry ) {
            filterValues.push({
                industry: [industry]
            });
        }

        if( leaseforsale ) {
            filterValues.push({
                leaseforsale: [leaseforsale]
            });
        }

        if( country ) {
            filterValues.push({
                country: [country]
            });
        }

        if( region ) {
            filterValues.push({
                region: [region]
            });
        }

        if( city ) {
            filterValues.push({
                city: [city]
            });
        }

        // first level of filtering
        let filtered_data = filterListings(filterValues);

        // second level of filtering
        if( from || to ) {
            const from = from || 0;
            const to = to || 0;

            filtered_data = filterListingsBySize(from, to);
        }

        buildMapUI(filtered_data);
        buildListUI(filtered_data);
}

window.initClusterMap = function () {
    const endpoint = '';
    $.ajax({
        url: endpoint,
        contentType: "application/json",
        dataType: 'json',
        success: function(result){
            console.log(result);
        },
        error: function() {
            setTimeout(function() {
                buildMapUI(listings);
                buildListUI(listings);
                mayBeFilterListings();
            }, 3000);
        }
    })
};

const mapTheme = [
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e9e9e9"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 29
            },
            {
                "weight": 0.2
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 18
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dedede"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "saturation": 36
            },
            {
                "color": "#333333"
            },
            {
                "lightness": 40
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f2f2f2"
            },
            {
                "lightness": 19
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 17
            },
            {
                "weight": 1.2
            }
        ]
    }
];

const filterButton = function() {
    const mapViewButton = $('#mapView__filtersMobile');
    const container = $('#mapFilters');

    $(mapViewButton).click(function(e) {
        $(container).toggleClass("is-active");
    });
};

const viewButton = function() {
    const mapViewButton = $('#mapView__switch');
    const container = $('#mapView__map');

    $(mapViewButton).click(function(e) {
        $(container).toggleClass("is-list-view");
    });
};

const statusButton = function() {
    const filterButton = $('#filterMapByStatus');

    filterButton.click(function(e) {
        e.preventDefault();

        // cache results element
        // get form inputs
        let filterValues = [];
        
        filterValues.push({
            status: ["available"]
        });
   
        let filtered_data = filterListings(filterValues);

        buildMapUI(filtered_data);
        buildListUI(filtered_data);
    });
};

const searchButton = function() {
    const filterButton = $('#filterMap');

    filterButton.click(function(e) {
        e.preventDefault();

        // cache results element
        // get form inputs
        let filterValues = [];
        const $form = $(this).parents('form')[0];
        console.log('form', $form);
        const formData = new FormData($form);

        console.log('formData', formData);

        if( formData.get('type') ) {

            console.log('searchButton > type: ' + formData.get('type'));

            filterValues.push({
                type: [formData.get('type')]
            });
        }

        if( formData.get('industry') ) {

            console.log('searchButton > industry: ' + formData.get('industry'));

            filterValues.push({
                industry: [formData.get('industry')]
            });
        }

        if( formData.get('leaseForSale') ) {

            console.log('searchButton > leaseforsale: ' + formData.get('leaseForSale'));

            filterValues.push({
                leaseforsale: [formData.get('leaseForSale')]
            });
        }

        if( formData.get('country') ) {

            console.log('searchButton > country: ' + formData.get('country'));

            filterValues.push({
                country: [formData.get('country')]
            });
        }

        if( formData.get('region') ) {

            console.log('searchButton > region: ' + formData.get('region'));

            filterValues.push({
                region: [formData.get('region')]
            });
        }

        if( formData.get('city') ) {

            console.log('searchButton > city: ' + formData.get('city'));

            filterValues.push({
                city: [formData.get('city')]
            });
        }

        // first level of filtering
        let filtered_data = filterListings(filterValues);

        // second level of filtering
        if( formData.get('from') || formData.get('to') ) {
            const from = formData.get('from') || 0;
            const to = formData.get('to') || 0;

            filtered_data = filterListingsBySize(from, to);
        }

        buildMapUI(filtered_data);
        buildListUI(filtered_data);

        // recentre?
    });
};

const filterListingsBySize = function(from, to) {
    console.log('filterListingsBySize > from-' + from);
    console.log('filterListingsBySize > to-' + to);

    var fromInt = parseInt(from);
    var toInt = parseInt(to);

    let result = listings.filter(function(l) {

        var sizeInt = parseInt(l.size);

        if (sizeInt >= fromInt && sizeInt <= toInt){
            console.log('filterListingsBySize > size-' + sizeInt + ' success!');
            return l;
        } else {
            console.log('filterListingsBySize > size-' + sizeInt + ' failed!!!!!!');
        }

        // if( ( from <= l.size || from == 0 ) && ( l.size <= to || to == 0 ) ) {
        //     return l;
        // }
    });
    return result;
}

const filterListings = function(filterBy) {
    console.log('filterListings...');
    let result = listings.filter(function (o) {
        return filterBy.every(element => {
            return Object.keys(element).every(function (k) {
                return element[k].some(function (f) {
                    return o[k] === f;
                });
            });
        });
        
    });
    return result;
}

const maybePluralize = (count, noun, suffix = 's') =>
  `${count} ${noun}${count !== 1 ? suffix : ''}`;

const updateListingsCount = function(count) {
    const wrapper = $('#listingsCount');
    wrapper.html(maybePluralize(count, 'result'));
}

const buildListUI = function(listings) {
    const $wrapper = $('#listViewContainer');
    $wrapper.html("");
    listings.forEach(listing => {
        $wrapper.append(
            '<div class="col-4">' +
                '<div class="articleRounded">' +
                    '<a href="' + listing.link + '" class="">'  +
                        '<div class="articleRounded__wrapper">'+
                            '<div class="articleRounded__img backgroundImage" style="background-image: url(' + listing.img + ')"></div>' +
                            '<div class="articleRounded__content">' +
                                '<div class="articleRounded__content-wrapper">' +
                                    '<h6 class="">' + listing.title + '</h6>' +
                                    '<p class="" style="max-width:200px">' + listing.address + '</p>' +
                                '</div>' +
                            '</div>'+
                            '<div class="articleRounded__icon">' +
                                '<svg><use xlink:href="#arrow-right"></use></svg>' +
                            '</div>' +
                        '</div>' +
                    '</a>' +
                '</div>' +
            '</div>'
        ); 
    });
};

const buildMapUI = function(listings) {
    
    updateListingsCount(listings.length);

    var lat = 39.85599712105477;
    var lng = -101.31795669457483;

    if (typeof listings != "undefined" && typeof listings[0] != "undefined" && typeof listings[0].pos != "undefined") {
        lat = listings[0].pos.lat; // 39.85599712105477
        lng = listings[0].pos.lng; // -101.31795669457483
    }

    console.log("listings.length: " + listings.length);

    const map = new google.maps.Map(document.getElementById("map"), {
        zoom: 3,
        center: { lat: lat, lng: lng },
        styles: mapTheme
    });

    const infoWindow = new google.maps.InfoWindow({
        content: "",
        disableAutoPan: true,
    });
 
    const svg = window.btoa(`
    <svg fill="#173E34" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
        <circle cx="120" cy="120" opacity="1" r="70" />    
    </svg>`);

    const renderer = {
        render: ({ count, position }) =>
          new google.maps.Marker({
            label: { text: String(count), color: "white", fontSize: "10px" },
            position,
            icon: {
                url: `data:image/svg+xml;base64,${svg}`,
                scaledSize: new google.maps.Size(75, 75)
            },
            // adjust zIndex to be above other markers
            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
          }),
      };

    // Add some markers to the map.
    const markers = listings.map((listing, i) => {
        const marker = new google.maps.Marker({
            position: listing.pos,
            icon: {
                url: listing.icon,
                scaledSize: new google.maps.Size(27, 38)
            }
        });

        // markers can only be keyboard focusable when they have click listeners
        // open info window when marker is clicked
        marker.addListener("click", () => {
            map.setCenter(marker.getPosition());   
            map.panBy(0, -200);
            infoWindow.setContent(getInfoWindowContent(listing));
            infoWindow.open(map, marker);
        });

        return marker;
    });

    new MarkerClusterer({ markers, map, renderer });
}

const getGoogleClusterInlineSvg = function(color) {
    var encoded = window.btoa('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-100 -100 200 200"><defs><g id="a" transform="rotate(45)"><path d="M0 47A47 47 0 0 0 47 0L62 0A62 62 0 0 1 0 62Z" fill-opacity="0.7"/><path d="M0 67A67 67 0 0 0 67 0L81 0A81 81 0 0 1 0 81Z" fill-opacity="0.5"/><path d="M0 86A86 86 0 0 0 86 0L100 0A100 100 0 0 1 0 100Z" fill-opacity="0.3"/></g></defs><g fill="' + color + '"><circle r="42"/><use xlink:href="#a"/><g transform="rotate(120)"><use xlink:href="#a"/></g><g transform="rotate(240)"><use xlink:href="#a"/></g></g></svg>');

    return ('data:image/svg+xml;base64,' + encoded);
};

if( process.env.NODE_ENV === 'development' ) {
    const listings = [
        {
            pos: { lat: -31.56391, lng: 147.154312 },
            category: "healthcare",
            img: "https://place-hold.it/400x200",
            icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/parking_lot_maps.png",
            title: "Example Location 1",
            address: "121-27 Tudhoe Street<br> Wagain WA 6315",
            link: "https://google.com",
            type: "residential",
            industry: "retail",
            leaseforsale: "lease",
            region: "usa",
            city: "washington",
            size: 400,
            status: "available"
        },
        {
            pos: {lat: -33.718234, lng: 150.363181},
            category: "retail",
            img: "https://place-hold.it/400x200",
            icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/parking_lot_maps.png",
            title: "Example Location 2",
            address: "221-27 Tudhoe Street<br> Wagain WA 6315",
            link: "https://google.com",
            type: "industrial",
            industry: "commercial",
            leaseforsale: "forsale",
            region: "usa",
            city: "washington",
            size: 100,
            status: "available"
        },
        {
            pos: {lat: -33.727111, lng: 150.371124},
            category: "retail",
            img: "https://place-hold.it/400x200",
            icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/parking_lot_maps.png",
            title: "Example Location 3",
            address: "321-27 Tudhoe Street<br> Wagain WA 6315",
            link: "https://google.com",
            type: "industrial",
            industry: "retail",
            leaseforsale: "lease",
            region: "usa",
            city: "washington",
            size: 100,
            status: "available"
        },
        {
            pos: {lat: -33.848588, lng: 151.209834},
            category: "retail",
            img: "https://place-hold.it/400x200",
            icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/parking_lot_maps.png",
            title: "Example Location 3",
            address: "321-27 Tudhoe Street<br> Wagain WA 6315",
            link: "https://google.com",
            type: "industrial",
            industry: "retail",
            leaseforsale: "lease",
            region: "usa",
            city: "washington",
            size: 100,
            status: "sold"
        }
    ];
}

const getInfoWindowContent = function(listing) {
    console.log('getInfoWindowContent v2');
    const content = 
        '<div id="content">' +
            '<div id="siteNotice">' +
                '<div class="mapInfoBox">' +
                    '<div class="mapInfoBox__wrapper">' +
                        '<div class="mapInfoBox__img">' +
                        '<img src="' + listing.img + '">' +
                        '</div>' +
                        '<div class="mapInfoBox__content">' +
                            '<div class="mapInfoBox__content-wrapper">' +
                                '<h3 class="">' + listing.title + '</h3>' +
                                '<p>' + listing.address + '</p>' +
                            '</div>' +
                            '<a href="' + listing.link + '" class="mapInfoBox__link">' +
                                '<div class="articleRounded__icon">' +
                                    '<svg><use xlink:href="#arrow-right"></use></svg>' +
                                '</div>' +
                            '</a>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>';
    return content;
};